import React, { useEffect } from 'react';
import logo from '../../images/logo.png'
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import useAuth from '../../hooks/useAuth';
import DatePicker from "react-datepicker";

const DriverOutlets = () => {

    const { user, vehicleData, setVehicleData, setOutletCode, setDeliveryOutlets, startDate, setStartDate, endDate, setEndDate } = useAuth()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`http://localhost:5000/vehicleWiseData-email-date-range-vehicle/0/${startDate.toISOString().split('T')[0]}/${endDate.toISOString().split('T')[0]}/${user.vehicle_reg_no}`)
            const result = await response.json()
            if (result.status === true) {
                setVehicleData(result.vehicleWiseData[0])
                setDeliveryOutlets(result?.vehicleWiseData[0]?.deliveryOutlets)
            }
        }
        user.vehicle_reg_no ? fetchData() : navigate('/')

    }, [user.vehicle_reg_no, setVehicleData, setDeliveryOutlets, navigate, startDate, endDate])

    const onSubmit = (data) => {
        const fetchData = async () => {
            try {
                const response = await fetch(`http://localhost:5000/vehicleWiseData/${vehicleData._id}`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(user)
                })
                const result = await response.json()
                if (result.status) {
                    setOutletCode(data.outlet)
                    document.getElementById('outlet_details_form').reset()
                    navigate('/driver-tracking')
                }
            }
            catch {
                fetchData()
            }
        }
        fetchData()
    }

    console.log(vehicleData)

    return (
        <div className='bg-brand'>
            <div className="container">
                <div className="d-flex justify-content-center align-items-center pt-3">
                    <img className='img-fluid' src={logo} alt="vehicle" />
                    <h1 style={{ lineHeight: '50px' }} className='fw-bold mt-2'>eTracker</h1>
                </div>

                <div className="d-flex justify-content-between align-items-center pt-3">
                    <p className='mb-0 me-2'>From:</p>
                    <DatePicker
                        className='w-75 date-picker'
                        selected={startDate}
                        onChange={(date) => {
                            setStartDate(date)
                        }}
                    />

                    <p className='mb-0 me-2'>To:</p>
                    <DatePicker
                        className='w-75 date-picker'
                        selected={endDate}
                        onChange={(date) => {
                            setEndDate(date)
                        }}
                    />
                </div>

                <p className="my-3">
                    <small>Vehicle Registration No: <b>{user.vehicle_reg_no}</b></small>
                </p>

                <div className="my-3 bg-white shadow rounded p-2">
                    <h2 className='h6 text-center my-2'>Select Outlet</h2>
                    <form id='outlet_details_form' onSubmit={handleSubmit(onSubmit)}>
                        {
                            vehicleData?.email ?
                                vehicleData.deliveryOutlets.map(outlet =>
                                    outlet.grn_handover ?
                                        <p key={outlet.code}><s>{outlet.code} {outlet.name}</s></p>
                                        :
                                        <div className="my-2" key={outlet.code}>
                                            <input type="radio"
                                                name={`${outlet.name}`}
                                                id={`${outlet.code}`}
                                                value={`${outlet.code}`}
                                                {...register("outlet", { required: true })} />
                                            <label htmlFor={`${outlet.code}`} className='ms-1'>{outlet.code} {outlet.name}</label>
                                            {/* <input className='btn-brand-submit w-100' type="submit" value={'Start Delivery'} /> */}
                                        </div>
                                )
                                :
                                <p className='text-brand-danger text-center my-3'>No Outlets to Delivery for Selected Date</p>
                        }

                        {errors.outlet && <p className='text-brand-danger fw-bold my-1'>Select the outlet</p>}

                        {
                            vehicleData.email ?
                                vehicleData.deliveryOutlets.every(obj => 'grn_handover' in obj) ?
                                    <Link to='/'><button className='btn-brand-submit w-100'>Homepage</button></Link>
                                    :
                                    <input className='btn-brand-submit w-100' type="submit" value={'Start Delivery'} />
                                :
                                <Link to='/'><button className='btn-brand-submit w-100'>Homepage</button></Link>
                        }

                    </form>

                </div>
            </div>
        </div>
    );
};

export default DriverOutlets;